<template>
  <div class="home_page">
    <el-breadcrumb separator="/" style="line-height: 40px">
      <el-breadcrumb-item :to="{ name: 'basicInfo' }">个人中心</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ name: 'rdmsOrderList' }">rdms订单列表</el-breadcrumb-item>
      <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="order_detail">
      <div class="detail_body">
        <div class="detail_row flex-between">
          <div class="top_title">订单详情</div>
          <div class="">状态：
            <font v-if="orderDetail" style="color: red;">{{$getDictLabel('ORDER_STATUS' ,orderDetail.orderStatus)}}</font>
          </div>
        </div>
        <div v-if="orderDetail">
          <div class="detail_row">
            <!-- 去支付 -->
            <!-- <div v-show="orderDetail.orderStatus === '20'">
              <el-button class="top_btn1"
                        @click="openVoucher"
                        type="primary"
                        style="margin-right:20px"
                        v-show="orderDetail.payStatus == '20' && orderDetail.paymentType != '60'"
                        >上传支付凭证</el-button>
              <el-button class="top-btn3"
                        type="primary"
                        style="margin-right:20px"
                        v-show="(orderDetail.payStatus == '20' || orderDetail.payStatus == '22' || orderDetail.payStatus == '24' || orderDetail.payStatus == '27') && orderDetail.paymentType == '60'"
                        @click="openVoucher"
                        >查看支付凭证</el-button>
            </div> -->
            <div v-if="orderDetail">
              <el-button class="top_btn1"
                        @click="openVoucher"
                        type="primary"
                        style="margin-right:20px"
                        v-show="orderDetail.orderStatus === '20'"
                        >上传支付凭证</el-button>
              <el-button class="top-btn3"
                        type="primary"
                        style="margin-right:20px"
                        v-show="orderDetail.orderStatus !== '20'"
                        @click="openVoucher"
                        >查看支付凭证</el-button>
            </div>
          </div>
          <div class="detail_row flex-between">
            <div class="detail_row">
              <label class="flex-shrink">订单编号：</label>
              <div>{{orderDetail.orderCode}}</div>
            </div>
            <div class="detail_row">
              <label class="flex-shrink">用户名：</label>
              <div>{{orderDetail.userName}}</div>
            </div>
            <div class="detail_row">
              <label class="flex-shrink">订单来源：</label>
              <div>{{$getDictLabel('ORDER_SOURCE', orderDetail.orderSource)}}</div>
            </div>
          </div>
          <div class="detail_row flex-between">
            <div class="detail_row">
              <label class="flex-shrink">采购公司：</label>
              <div>{{orderDetail.companyName}}</div>
            </div>
          </div>
          <div class="detail_row flex-between">
            订单商品：
          </div>
          <el-table ref="goodsTable"
                    :data="orderDetail.payOrderItemVoList"
                    style="width: 906px"
                    size="small"
                    border>
            <el-table-column align="center" prop="goodsCode" label="商品编号"></el-table-column>
            <el-table-column prop="goodsName" align="center" label="商品名称"></el-table-column>
            <el-table-column align="center" prop="brandName" label="品牌"></el-table-column>
            <el-table-column align="center" prop="goodsModel" label="型号"
                            width="120"></el-table-column>
            <el-table-column align="center" prop="goodsNum"
                            label="数量"
                            width="70"></el-table-column>
            <el-table-column align="center" label="单价" width="130">
              <template slot-scope="scope">
                <span :label="scope.row.goodsPrice">{{scope.row.goodsPrice|formatePrice}}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="总价" width="130">
              <template slot-scope="scope">
                <span :label="scope.row.money">{{scope.row.money|formatePrice}}</span>
              </template>
            </el-table-column>
          </el-table>
          <!-- 优惠，总金额 -->
          <el-row style="background-color:#ebebeb; height:50px">
            <el-col :span="5"
                    :offset="19"
                    style="margin-top:10px">
              <span>总金额：<span style="color:red"><span>￥</span>{{orderDetail.payMoney|formatePrice}}</span></span>
            </el-col>
          </el-row>
          <div class="detail_row flex-between">
            联系商家：{{orderDetail.contactPhone || '商家暂未提供电话'}}
          </div>
          <!-- 合同模板 -->
          <div class="detail_row">
            订单合同： 宁东工业超市平台RDMS服务套餐购买合同.doc
            <label class="checkContract" @click="previewContractHandle">下载</label>
          </div>
          <div class="detail_row flex-between">备注</div>
          <el-input style="margin-top:20px"
                    type="textarea"
                    :disabled="true"
                    :autosize="{ minRows: 4, maxRows: 8}"
                    placeholder="请输入备注信息："
                    v-model="orderDetail.orderRemarks">
          </el-input>
        </div>
      </div>
      <!-- 上传合同 -->
      <el-dialog :title="orderDetail && orderDetail.orderStatus === '20' ? '上传支付凭证' : '查看支付凭证'"
                 :visible.sync="visible"
                 width="30%"
                 :close-on-click-modal="false"
                 :close-on-press-escape="false"
                 :show-close="true"
                 class="order-detail-dialog">
        <el-upload ref="contractUpload"
                   :action="uploadURL"
                   accept=".jpg,.png,.docx,.doc,.pdf"
                   :file-list="fileList"
                   :on-preview="previewHandle"
                   :on-exceed="handleExceed"
                   :limit="9"
                   :data="{ fileSuffixType: 'allType' }"
                   :with-credentials="true"
                   :headers="upLoadHeaders"
                   :on-success="handleSuccess"
                   :on-remove="removeHandle"
                   :disabled="orderDetail && (orderDetail.orderStatus !== '20' &&orderDetail.orderStatus !== '21')"
                   :before-upload="beforeUpload">
          <el-button style="margin-left: 10px;"
                     size="small"
                     type="primary"
                     class="upload-button"
                     v-show="orderDetail && (orderDetail.orderStatus == '20' || orderDetail.orderStatus == '21')">选择并上传</el-button>
        </el-upload>
        <span slot="footer" class="dialog-footer">
          <el-button @click="visible = false">取 消</el-button>
          <el-button type="primary" :loading="buttonLoading" :disabled="!fileList.length" @click="saveFile" v-show="orderDetail&&(orderDetail.orderStatus == '20' || orderDetail.orderStatus == '21')">确 认</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import Cookies from 'js-cookie'
import { getAccessToken } from '@/utils/userInfo'
export default {
  data () {
    return {
      buttonLoading: false,
      orderDetail: null,
      // 支付凭证模态框
      visible: false,
      fileList: [],
      payFileListNew: [],
      payFileListDel: [],
      uploadURL: window.SITE_CONFIG['apiURL'] + '/help/fileupload/sys/v2/upload',
      upLoadHeaders: {
        'Authorization': 'Bearer ' + getAccessToken()
      }
    }
  },
  computed: {
    orderId () {
      return this.$route.params.id
    }
  },
  watch: {
    orderId: {
      handler: 'getInfo',
      immediate: true
    }
  },
  methods: {
    // 查询订单详情
    getInfo () {
      if (!this.orderId) {
        return false
      }
      this.$request.get(`/front/consumer/order/orderInfo/${this.orderId}`)
        .then((res) => {
          this.orderDetail = res
        })
        .catch(() => {
          this.orderDetail = null
        })
    },
    // 支付凭证dialog打开
    openVoucher () {
      // if (this.orderDetail.orderStatus === 20) {}
      this.payFileListNew = []
      this.payFileListDel = []
      if (this.orderDetail.rdmsUrls && this.orderDetail.rdmsUrls.length) {
        this.fileList = this.orderDetail.rdmsUrls.map(item => {
          item.name = item.fileName
          item.id = item.aliOssId
          item.objectName = item.objectName
          item.url = item.url
          return item
        })
      } else {
        this.fileList = []
      }
      this.visible = true
    },
    // 校验上传
    beforeUpload (file) {
      let type = file.name.substring(file.name.lastIndexOf('.'))
      const isLt2M = file.size / 1024 / 1024 < 20
      var reg = /\.(jpg|docx|doc|png|pdf|PNG)$/
      const isJPG = reg.test(type)

      if (!isJPG) {
        this.$message.error('上传文件只能是 jpg|docx|doc|png|pdf 格式!')
        return false
      }
      if (!isLt2M) {
        this.$message.error('上传文件大小不能超过 20MB!')
        return false
      }
      let newName = file.name.slice(0, file.name.lastIndexOf('.'))
      let regx = /^[\u4E00-\u9FA5A-Za-z0-9]+$/
      if (regx.test(newName)) {
      } else {
        this.$message.warning('文件名只能由数字、英文字母、汉字组成，不能有空格 + 《 》等特殊符号')
        return false
      }
      return isJPG && isLt2M
    },
    // 上传成功
    handleSuccess (res) {
      if (res.code === 0) {
        this.$message({
          message: '上传成功',
          type: 'success'
        })
        this.fileList.push({
          objectName: res.data.objectName,
          fileName: res.data.fileName,
          name: res.data.fileName,
          url: res.data.url,
          id: res.data.aliOssId
        })
        this.payFileListNew.push(res.data.aliOssId)
      } else {
        this.$message({
          message: res.message,
          type: 'error'
        })
        this.$refs.contractUpload.uploadFiles.pop()
      }
    },
    // 删除支付凭证
    removeHandle (file, fileList) {
      this.payFileListDel.push(file)
      if (fileList.length) {
        this.fileList = fileList.map(item => {
          return {
            objectName: item.objectName,
            fileName: item.fileName,
            name: item.name,
            url: item.url,
            id: item.id
          }
        })
      } else {
        this.fileList = []
      }
    },
    // 点击查看
    previewHandle (file) {
      window.open(file.url)
    },
    handleExceed (files, fileList) {
      this.$message.warning(`当前限制选择 9 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
    },
    // 保存支付凭证
    saveFile () {
      // this.$
      if (this.buttonLoading) {
        return false
      }
      this.buttonLoading = true
      this.$http.post(`/front/consumer/fictitiousorder/uploadPaymentVoucher`, {
        orderId: this.orderDetail.orderId || this.orderId,
        aliFileList: this.fileList,
        aliFileDelList: this.payFileListDel
      })
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.getInfo()
            this.$message.success(res.message)
            this.visible = false
          } else {
            this.$message.error(res.message)
          }
        })
        .finally(() => {
          this.buttonLoading = false
        })
    },
    // 预览下载合同
    previewContractHandle () {
      let url = window.SITE_CONFIG['apiURL'] + '/front/consumer/fictitiousorder/downLoadContract?commodityName=' +
                this.orderDetail.payOrderItemVoList[0].goodsName +
                '&brandName=' + this.orderDetail.payOrderItemVoList[0].brandName +
                '&model=' + this.orderDetail.payOrderItemVoList[0].goodsModel +
                '&goodsPrice=' + this.orderDetail.payOrderItemVoList[0].goodsPrice +
                '&goodsNum=' + this.orderDetail.payOrderItemVoList[0].goodsNum +
                '&goodsMoney=' + this.orderDetail.payOrderItemVoList[0].money +
                '&userId=' + Cookies.get('userId')
      window.open(url)
    }
  }
}
</script>
<style lang='scss' scoped>
.order_detail{
  background: #fff;
  padding: 30px;
  .detail_body{
    width: 907px;
    margin: 0 auto;
    .discount{
      text-decoration: line-through;
      color: #aaaaaa;
    }
    .detail_row{
      display: flex;
      margin-top: 20px;
      color: #666666;
      align-items: center;
      .checkContract {
        margin-left: 20px;
        height: 36px;
        line-height: 36px;
        color: #1d65a8;
        cursor: pointer;
      }
      .item_col{
        margin-right: 30px;
      }
      .top_title{
        font-size: 20px;
        // margin-top: 40px;
        font-weight: 600;
        color: #333333;
      }
    }
    .flex-between{
      justify-content: space-between;
    }
  }
}
</style>
